import L from 'leaflet';

const TRUCK_180_SVG = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="669.000000pt" height="373.000000pt" viewBox="0 0 669.000000 373.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,373.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M49 3717 c-40 -30 -39 -18 -44 -1239 -5 -1112 -4 -1185 13 -1218 9
-20 32 -43 52 -53 33 -16 142 -17 2050 -12 1108 3 2027 5 2041 5 16 0 40 12
58 29 l31 29 0 1202 c0 1240 0 1227 -39 1257 -23 18 -4139 18 -4162 0z"/>
<path d="M4500 2903 c-38 -7 -85 -48 -105 -90 -17 -35 -18 -93 -20 -883 -1
-465 -3 -848 -4 -852 0 -5 -612 -8 -1358 -9 -977 0 -1351 -3 -1333 -11 123
-53 158 -75 224 -142 88 -87 131 -164 158 -281 27 -119 27 -119 80 -123 55 -4
78 15 78 63 l0 33 98 4 c53 2 212 3 352 3 l255 0 3 -50 c3 -72 9 -92 34 -115
21 -20 33 -20 579 -20 652 0 599 -10 608 111 l6 74 108 3 107 3 6 -30 c4 -16
17 -40 31 -53 22 -21 36 -23 133 -26 122 -4 150 4 150 45 0 44 38 166 72 229
41 76 148 182 229 226 143 78 304 94 454 43 44 -14 87 -32 95 -39 8 -6 28 -18
45 -26 16 -8 57 -43 90 -76 88 -88 138 -194 172 -359 l9 -40 318 -3 c192 -1
333 2 355 8 62 16 104 51 134 109 24 49 27 65 27 159 0 114 -15 154 -64 166
l-24 6 -4 272 c-5 289 -15 368 -65 533 -24 78 -88 210 -121 250 -10 11 -27 34
-38 50 -34 50 -153 222 -245 355 -46 66 -179 259 -232 338 -33 49 -78 85 -150
121 l-52 26 -585 1 c-322 1 -596 0 -610 -3z m1202 -254 c37 -18 124 -114 148
-164 3 -5 54 -84 114 -175 149 -226 152 -231 164 -265 16 -44 23 -151 14 -219
-5 -46 -12 -63 -32 -77 -24 -18 -30 -18 -105 -4 -44 8 -105 21 -135 29 -30 9
-185 47 -345 86 -159 39 -325 80 -367 90 -184 47 -236 60 -286 71 -93 20 -92
17 -92 337 0 242 2 278 17 294 15 17 42 18 439 18 408 0 425 -1 466 -21z
m-621 -995 c7 -20 6 -32 -6 -50 -15 -23 -20 -24 -150 -24 -123 0 -135 2 -145
19 -13 26 -13 54 2 69 8 8 56 12 150 12 l138 0 11 -26z m1433 -210 c13 -13 16
-42 16 -158 0 -97 -4 -146 -12 -154 -7 -7 -30 -12 -53 -12 -23 0 -46 5 -53 12
-8 8 -12 58 -12 158 0 100 4 150 12 158 17 17 84 15 102 -4z"/>
<path d="M427 1063 c-4 -3 -7 -37 -7 -75 l0 -68 -30 0 c-41 0 -80 -20 -86 -44
-3 -12 -4 -68 -2 -126 l3 -105 35 -17 c30 -15 65 -18 243 -18 l207 0 0 -44 c0
-37 4 -45 23 -50 55 -15 107 -4 107 23 0 35 43 187 64 226 72 135 187 238 320
285 51 18 47 19 -410 19 -253 1 -464 -2 -467 -6z"/>
<path d="M1394 956 c-88 -21 -167 -66 -221 -126 -88 -96 -121 -168 -129 -280
-12 -153 30 -266 136 -371 71 -70 130 -103 219 -123 88 -20 127 -20 205 0 93
24 160 61 220 122 69 70 110 146 130 244 14 68 14 85 1 160 -19 108 -55 178
-131 254 -113 114 -273 158 -430 120z m239 -249 c26 -18 50 -40 53 -49 3 -10
9 -18 13 -18 19 0 36 -69 36 -141 0 -68 -4 -81 -30 -119 -39 -57 -79 -85 -145
-104 -54 -15 -66 -14 -150 10 -61 18 -124 94 -140 168 -43 211 186 371 363
253z"/>
<path d="M5160 956 c-130 -29 -255 -131 -314 -255 -30 -64 -31 -71 -31 -196 0
-127 1 -132 34 -199 62 -127 172 -214 317 -250 81 -21 135 -20 214 3 86 24
135 50 192 100 201 177 209 489 18 678 -111 110 -271 154 -430 119z m212 -232
c39 -20 98 -84 116 -124 19 -45 19 -145 0 -190 -20 -47 -86 -109 -134 -127
-159 -57 -324 55 -324 222 0 111 79 216 179 236 46 9 128 1 163 -17z"/>
</g>
</svg>`;

const TRUCK_45_SVG = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="669.000000pt" height="373.000000pt" viewBox="0 0 669.000000 373.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,373.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M4030 3432 c-45 -20 -158 -110 -248 -196 -29 -28 -58 -53 -63 -55 -6
-2 -21 7 -34 19 -29 27 -133 70 -154 63 -24 -9 -51 -34 -51 -49 0 -12 100 -74
122 -74 6 0 19 7 28 15 15 14 18 14 30 -1 12 -14 -7 -36 -153 -177 -143 -138
-167 -166 -167 -192 0 -25 53 -82 388 -418 213 -214 396 -392 407 -397 36 -14
69 10 222 162 132 132 154 150 168 138 14 -12 14 -15 0 -30 -8 -9 -15 -26 -15
-36 0 -30 48 -124 63 -124 8 0 24 11 36 24 22 23 23 27 11 78 -15 64 -31 97
-59 122 l-21 19 73 76 c107 110 195 226 202 264 11 59 -36 139 -198 337 -114
139 -308 316 -452 413 -39 27 -99 35 -135 19z m137 -78 c94 -63 102 -72 83
-84 -8 -5 -26 -10 -40 -10 -29 0 -195 81 -195 95 0 9 61 45 77 45 4 0 37 -21
75 -46z m-211 -220 c88 -60 203 -151 277 -223 131 -125 317 -383 317 -439 0
-27 -8 -33 -106 -81 -59 -28 -114 -49 -123 -46 -9 2 -22 15 -30 26 -36 59
-176 224 -261 309 -104 105 -131 129 -232 209 -41 31 -68 60 -68 71 0 11 23
64 51 120 62 121 70 123 175 54z m-265 -91 c-29 -59 -59 -97 -119 -155 -44
-43 -83 -78 -87 -78 -14 0 -45 21 -45 31 0 11 271 278 283 279 4 0 -10 -35
-32 -77z m1031 -259 c55 -80 61 -118 24 -153 -28 -26 -25 -29 -71 80 -33 80
-43 128 -28 143 13 12 27 0 75 -70z m-249 -467 c-46 -57 -248 -257 -259 -257
-20 0 -36 37 -25 58 20 38 169 164 226 191 74 36 81 37 58 8z"/>
<path d="M2463 2040 c-548 -546 -733 -736 -733 -754 0 -17 115 -137 444 -466
245 -244 451 -447 458 -451 7 -5 19 -9 27 -9 7 0 343 329 747 732 580 578 734
737 734 757 0 20 -97 121 -450 473 -321 319 -457 448 -473 448 -16 0 -228
-206 -754 -730z"/>
</g>
</svg>`;

const TRUCK_90_SVG = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="669.000000pt" height="373.000000pt" viewBox="0 0 669.000000 373.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,373.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M2712 3428 c-15 -15 -17 -2034 -2 -2058 8 -13 90 -15 634 -15 433 0
628 3 636 11 15 15 14 2042 -1 2061 -16 18 -1248 20 -1267 1z"/>
<path d="M2792 1277 c-21 -23 -22 -31 -22 -255 0 -225 -1 -232 -20 -232 -13 0
-20 7 -20 18 0 26 -27 48 -75 61 -68 18 -75 16 -75 -27 0 -36 3 -39 61 -70 38
-20 75 -32 100 -32 l39 0 0 -62 c1 -80 24 -259 38 -284 20 -38 49 -52 152 -75
96 -22 128 -24 375 -24 250 0 278 2 378 24 126 29 149 47 166 133 11 53 30
222 31 266 0 19 5 22 35 22 34 0 132 43 147 64 4 6 8 26 8 45 0 34 0 34 -39
27 -66 -10 -92 -24 -104 -56 -7 -18 -19 -30 -29 -30 -17 0 -18 16 -18 239 0
237 0 240 -22 255 -20 14 -89 16 -553 16 l-532 0 -21 -23z m71 -114 c3 -10 8
-58 11 -108 6 -79 4 -98 -18 -158 -13 -37 -26 -71 -30 -74 -3 -4 -6 32 -7 78
0 46 -3 128 -5 182 l-4 97 24 0 c15 0 27 -7 29 -17z m1007 -160 l-1 -178 -22
40 c-17 32 -22 61 -25 153 -5 132 0 162 28 162 19 0 20 -7 20 -177z m-715 -98
c169 -13 211 -13 389 1 109 8 204 13 211 10 12 -4 75 -181 75 -211 0 -23 -76
-54 -162 -65 -40 -5 -97 -14 -127 -20 -69 -13 -308 -13 -386 0 -33 6 -93 15
-133 20 -81 11 -162 42 -162 62 0 13 38 136 60 193 11 29 -5 29 235 10z m-190
-463 c80 -29 105 -47 105 -74 0 -21 6 -21 -100 0 -77 16 -86 21 -103 50 -11
18 -16 39 -13 47 6 16 5 16 111 -23z m867 -1 c-2 -16 -11 -36 -21 -44 -17 -15
-181 -51 -190 -41 -3 3 1 17 9 31 14 23 69 50 170 82 33 11 37 7 32 -28z"/>
</g>
</svg>`;

const getIconConfig = (
  course: number
): {
  svg: string;
  scaleX: number;
  scaleY: number;
  rotation: number;
  scale: number;
} => {
  const normalizedCourse = ((course % 360) + 360) % 360;

  let svg = TRUCK_180_SVG;
  let scaleX = 1;
  let scaleY = 1;
  let rotation = 0;
  let scale = 0.5;

  if (normalizedCourse >= 30 && normalizedCourse < 60) {
    svg = TRUCK_45_SVG;
    scaleX = -1;
    scaleY = 1;
    scale = 1;
  } else if (normalizedCourse >= 60 && normalizedCourse < 120) {
    svg = TRUCK_90_SVG;
    scaleX = -1;
    scaleY = -1;
    scale = 1;
  } else if (normalizedCourse >= 120 && normalizedCourse < 150) {
    svg = TRUCK_45_SVG;
    scaleX = 1;
    scaleY = 1;
    scale = 1;
  } else if (normalizedCourse >= 150 && normalizedCourse < 210) {
    svg = TRUCK_180_SVG;
    scaleX = 1;
    scaleY = 1;
    scale = 0.5;
  } else if (normalizedCourse >= 210 && normalizedCourse < 240) {
    svg = TRUCK_45_SVG;
    scaleX = 1;
    scaleY = -1;
    scale = 1;
  } else if (normalizedCourse >= 240 && normalizedCourse < 300) {
    svg = TRUCK_90_SVG;
    scaleX = 1;
    scaleY = 1;
    scale = 1;
  } else if (normalizedCourse >= 300 && normalizedCourse < 330) {
    svg = TRUCK_45_SVG;
    scaleX = -1;
    scaleY = -1;
    scale = 1;
  } else {
    svg = TRUCK_180_SVG;
    scaleX = -1;
    scaleY = 1;
    scale = 0.5;
  }

  return { svg, scaleX, scaleY, rotation, scale };
};

export const createDriverMarkerIcon = (course: number = 0): string => {
  const { svg, scaleX, scaleY, rotation, scale } = getIconConfig(course);

  return `<div style="
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    filter: drop-shadow(0 3px 6px rgba(0,0,0,0.4));
    transform: rotate(${rotation}deg) scaleX(${scaleX}) scaleY(${scaleY}) scale(${scale});
    transition: transform 0.5s cubic-bezier(0.4, 0.0, 0.2, 1);
  ">
    ${svg}
  </div>`;
};

export const createLeafletDriverIcon = (course: number = 0): L.DivIcon => {
  return L.divIcon({
    className: 'driver-marker',
    html: createDriverMarkerIcon(course),
    iconSize: [40, 40],
    iconAnchor: [20, 40],
  });
};
